import * as THREE from 'three';
import Application from '../Application';
export default class Stars {
    constructor() {
        this.application = new Application();
        this.scene = this.application.scene;
        this.time = this.application.time;
        this.setStars();
    }
    setStars() {
        const count = 2000;
        const positions = new Float32Array(count * 3);
        const sizes = new Float32Array(count);
        const innerRadius = 50000;
        const outerRadius = 200000;
        for (let i = 0; i < count; i++) {
            const i3 = i * 3;
            // Distribute stars in a spherical shell above the horizon
            const radius = innerRadius + Math.random() * (outerRadius - innerRadius);
            const theta = Math.random() * Math.PI * 2; // full rotation
            const phi = Math.random() * Math.PI * 0.5; // upper hemisphere only
            positions[i3] = radius * Math.sin(phi) * Math.cos(theta);
            positions[i3 + 1] =
                radius * Math.cos(phi) + 5000; // offset upward
            positions[i3 + 2] = radius * Math.sin(phi) * Math.sin(theta);
            // Vary star sizes for depth
            sizes[i] = 50 + Math.random() * 200;
        }
        const geometry = new THREE.BufferGeometry();
        geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));
        geometry.setAttribute('size', new THREE.BufferAttribute(sizes, 1));
        this.material = new THREE.PointsMaterial({
            color: 0xffffff,
            size: 400,
            sizeAttenuation: true,
            transparent: true,
            opacity: 0.9,
            depthWrite: false,
        });
        this.points = new THREE.Points(geometry, this.material);
        this.scene.add(this.points);
    }
    update() {
        // Gentle slow rotation for subtle movement
        this.points.rotation.y = this.time.elapsed * 0.000002;
    }
}
